export default __webpack_public_path__ + "static/media/our-process-one.f8388b2d.jpg";